import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        loadingScreenContainer: {
            display: 'flex',
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        },
        linearRoot: {
            height: 15,
            borderRadius: 17,
            width: 270,
            margin: `${theme.spacing(3)}px 0`,
        },
        linearColorPrimary: {
            backgroundColor: '#e4ebff',
        },
        linearBar: {
            borderRadius: 5,
            backgroundColor: '#7595f0',
        },
        linearBarComplete: {
            borderRadius: 5,
            backgroundColor: '#01a7a7',
        },
    }),
);
